import { render, staticRenderFns } from "./voice-input-button.vue?vue&type=template&id=7b28397d&scoped=true&"
import script from "./voice-input-button.vue?vue&type=script&lang=js&"
export * from "./voice-input-button.vue?vue&type=script&lang=js&"
import style0 from "./voice-input-button.vue?vue&type=style&index=0&id=7b28397d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b28397d",
  null
  
)

export default component.exports